import { NavBar, Form, Button, Selector, Input, Toast, Popup, SearchBar } from 'antd-mobile'
import React, { useCallback, useEffect, useState, useMemo } from 'react'
import UploadImgToOss from './uploadImg';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.css'
import { teamApi } from '../../features/team/api/teamApi';

export default function CreateTeam() {

    const location = useLocation();
    const navigate = useNavigate();
    const gameYearId = location.state?.yearId;


    const [formCommitLoading, setFormCommitLoading] = useState(false)
    const [imageUrl, setImageUrl] = useState("https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/kplogo.png")
    const [memberList, setMemberList] = useState([])
    const [captainInfo, setCaptainInfo] = useState()
    const [teamType, setTeamType] = useState([0])
    const [memberList1, setMemberList1] = useState([])
    const [memberList2, setMemberList2] = useState([])

    const [isCaptainPopupShow, setIsCaptainPopupShow] = useState(false)
    const [captainSearchKey, setCaptainSearchKey] = useState('')
    const [memberSearchKey, setMemberSearchKey] = useState('')
    const [showAllMembers, setShowAllMembers] = useState(false)

    const getUserList = useCallback(() => {
        Toast.show({
            icon: 'loading',
        })
        teamApi.getAvailableMembers(gameYearId)
            .then(function (response) {
                setMemberList(response.data.data)
            })
            .catch(function (error) {
                console.error('获取成员列表失败', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameYearId])

    useEffect(() => {
        // 创建页依赖年会 ID，直接打开无上下文的路由时返回活动列表。
        if (!gameYearId) {
            navigate('/gameYearList', { replace: true });
            return;
        }
        getUserList()
    }, [gameYearId, getUserList, navigate])

    const onFinish = (values) => {
        if (!captainInfo && teamType[0] === 0) {
            Toast.show('请选择队长');
            return;
        }

        Toast.show({
            icon: "loading",
            duration: 0
        })
        setFormCommitLoading(true)
        teamApi.create({
            teamName: values.teamName,
            teamType: teamType[0],
            teamCaptain: captainInfo?.items[0]?.value,
            teamLogo: imageUrl || '',
            yearId: gameYearId,
            memberInfo: memberList1.concat(memberList2).join(",")
        })
            .then(function (response) {
                if (response.data.code !== 200) {
                    Toast.show({ icon: 'fail', content: response.data.msg || '创建失败' });
                    return;
                }
                Toast.show({ icon: 'success', content: '创建成功' });
                window.history.back();
            })
            .catch(function () {
                Toast.show({
                    icon: 'fail',
                    content: "操作失败，请联系管理员！",
                })
            })
            .finally(() => {
                setFormCommitLoading(false)
                Toast.clear()
            });
    };

    // Filtered members for captain selection
    const filteredMembers = useMemo(() => {
        if (!captainSearchKey) return memberList;
        return memberList.filter(item =>
            item.name.toLowerCase().includes(captainSearchKey.toLowerCase())
        );
    }, [memberList, captainSearchKey]);


    return (
        <div className="create-team-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                创建队伍
            </NavBar>

            <Form
                className='create-team-form'
                name='form'
                onFinish={onFinish}
                layout='vertical'
                footer={
                    <div className="team-submit-btn-box">
                        <Button
                            block
                            type='submit'
                            color='success'
                            className="team-submit-btn"
                            loading={formCommitLoading}
                        >
                            提交队伍
                        </Button>
                    </div>
                }
                initialValues={{
                    teamType: [0]
                }}
            >
                <div className="create-team-header-main">
                    <div className="create-team-title">队伍基本信息</div>
                </div>

                <div className="logo-upload-wrapper">
                    {teamType[0] === 1 && <div className="create-team-logo-hint">外战队徽可选；留空时比赛页面显示圆形队名。</div>}
                    <UploadImgToOss
                        onChange={(value) => setImageUrl(value)}
                        value={imageUrl}
                    />
                </div>

                <Form.Item
                    name='teamType'
                    label={<span className="create-team-label">队伍类型</span>}
                    rules={[{ required: true }]}
                >
                    <Selector
                        className="premium-selector"
                        columns={2}
                        options={[
                            { label: '科朋队伍', value: 0 },
                            { label: '外战队伍', value: 1 }
                        ]}
                        onChange={(arr) => {
                            // 外战队伍不默认套用科朋队徽，切回科朋队伍时恢复默认徽标。
                            setTeamType(arr)
                            setImageUrl(arr[0] === 1 ? '' : 'https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/kplogo.png')
                        }}
                    />
                </Form.Item>

                <Form.Item
                    name='teamName'
                    label={<span className="create-team-label">队伍名称</span>}
                    rules={[{ required: true }]}>
                    <Input placeholder='请输入简洁大气的队伍名称' style={{ fontSize: '15px', fontWeight: '500' }} />
                </Form.Item>

                {teamType && teamType[0] === 0 && (
                    <>
                        <Form.Item
                            label={<span className="create-team-label">队长选派</span>}
                        >
                            <Button
                                color='primary'
                                fill='outline'
                                style={{ borderRadius: '12px', fontSize: '14px', height: '44px', width: '100%' }}
                                onClick={() => {
                                    setCaptainSearchKey('')
                                    setIsCaptainPopupShow(true)
                                }}
                            >
                                {captainInfo ? `已选队长：${captainInfo.items[0].label}` : '点击从成员库中选择队长'}
                            </Button>
                        </Form.Item>

                        <Form.Item
                            label={<span className="create-team-label">成员配置</span>}
                        >
                            <div style={{ marginBottom: '16px' }}>
                                <div className="create-team-sub-label">已选人员清单 ({memberList1.length + memberList2.length})</div>
                                {(memberList1.length + memberList2.length) > 0 ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '12px', background: '#f5f7fa', borderRadius: '16px', border: '1px solid #e5e6eb' }}>
                                        {memberList1.map(id => {
                                            const m = memberList.find(item => item.id === id);
                                            return m ? (
                                                <span
                                                    key={id}
                                                    style={{ background: '#fff', color: '#165DFF', padding: '5px 12px', borderRadius: '10px', fontSize: '13px', fontWeight: '700', border: '1px solid rgba(22, 93, 255, 0.2)', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                                                    onClick={() => setMemberList1(memberList1.filter(v => v !== id))}
                                                >
                                                    {m.name} <span style={{ opacity: 0.5, fontWeight: 'normal' }}> (科)</span> ×
                                                </span>
                                            ) : null;
                                        })}
                                        {memberList2.map(id => {
                                            const m = memberList.find(item => item.id === id);
                                            return m ? (
                                                <span
                                                    key={id}
                                                    style={{ background: '#fff', color: '#ff4d4f', padding: '5px 12px', borderRadius: '10px', fontSize: '13px', fontWeight: '700', border: '1px solid rgba(255, 77, 79, 0.2)', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}
                                                    onClick={() => setMemberList2(memberList2.filter(v => v !== id))}
                                                >
                                                    {m.name} <span style={{ opacity: 0.5, fontWeight: 'normal' }}> (临)</span> ×
                                                </span>
                                            ) : null;
                                        })}
                                    </div>
                                ) : <div style={{ color: '#86909c', fontSize: '13px', padding: '10px', background: '#f5f7fa', borderRadius: '12px', textAlign: 'center' }}>尚未选择队员，请从下方库中添加</div>}
                            </div>

                            <div style={{ background: '#fff', borderRadius: '16px', border: '1px solid #f2f3f5', overflow: 'hidden' }}>
                                <details style={{ width: '100%' }}>
                                    <summary style={{
                                        listStyle: 'none',
                                        padding: '12px 16px',
                                        background: '#f8f9fa',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                        fontWeight: '800',
                                        color: '#165DFF',
                                        fontSize: '14px'
                                    }}>
                                        <span>🔍 搜索并添加队员</span>
                                        <span style={{ fontSize: '12px', opacity: 0.6 }}>▼</span>
                                    </summary>

                                    <div style={{ padding: '16px' }}>
                                        <SearchBar
                                            placeholder='输入姓名快速检索'
                                            style={{ '--background': '#fff', '--border-radius': '10px', marginBottom: '16px', border: '1px solid #e5e6eb' }}
                                            onChange={val => setMemberSearchKey(val)}
                                        />

                                        <div className="create-team-sub-label" style={{ marginTop: 0 }}>科朋队员库</div>
                                        <Selector
                                            className="premium-selector"
                                            columns={3}
                                            options={memberList
                                                ?.filter(item => item.tempMember === null && item.id !== captainInfo?.items[0].value)
                                                ?.filter(item => !memberSearchKey || item.name.toLowerCase().includes(memberSearchKey.toLowerCase()))
                                                ?.slice(0, showAllMembers || memberSearchKey ? undefined : 18)
                                                ?.map(item => ({ label: item.name, value: item.id }))}
                                            multiple
                                            value={memberList1}
                                            onChange={(arr) => setMemberList1(arr)}
                                        />

                                        <div className="create-team-sub-label" style={{ marginTop: '20px' }}>临时队员库</div>
                                        <Selector
                                            className="premium-selector"
                                            columns={3}
                                            options={memberList
                                                ?.filter(item => [1, 2].includes(item.tempMember) && item.id !== captainInfo?.items[0].value)
                                                ?.filter(item => !memberSearchKey || item.name.toLowerCase().includes(memberSearchKey.toLowerCase()))
                                                ?.slice(0, showAllMembers || memberSearchKey ? undefined : 18)
                                                ?.map(item => ({ label: item.name, value: item.id }))}
                                            multiple
                                            value={memberList2}
                                            onChange={(arr) => setMemberList2(arr)}
                                        />
                                        {!memberSearchKey && !showAllMembers && <Button fill="none" size="small" onClick={() => setShowAllMembers(true)}>显示全部队员</Button>}
                                    </div>
                                </details>
                            </div>
                        </Form.Item>
                    </>
                )}
            </Form>

            <Popup
                visible={isCaptainPopupShow}
                onMaskClick={() => setIsCaptainPopupShow(false)}
                bodyClassName="captain-selection-popup"
                bodyStyle={{ maxHeight: '85vh', minHeight: '60vh', display: 'flex', flexDirection: 'column' }}
            >
                <div className="captain-popup-header">
                    <div className="captain-popup-title">请选择队长</div>
                    <SearchBar
                        placeholder='输入姓名模糊搜索'
                        style={{ '--background': '#f2f3f5', '--border-radius': '10px' }}
                        onChange={val => setCaptainSearchKey(val)}
                    />
                </div>

                <div className="captain-popup-body">
                    <span className="create-team-sub-label" style={{ marginTop: 0 }}>科朋队员</span>
                    {filteredMembers
                        .filter(item => item.tempMember === null)
                        // Exclude players already selected as members
                        .filter(item => !memberList1.includes(item.id) && !memberList2.includes(item.id))
                        .length > 0 ? (
                        <Selector
                            className="premium-selector"
                            columns={3}
                            options={filteredMembers
                                .filter(item => item.tempMember === null)
                                .filter(item => !memberList1.includes(item.id) && !memberList2.includes(item.id))
                                .map(item => ({ label: item.name, value: item.id }))}
                            onChange={(arr, extend) => {
                                if (extend.items.length > 0) {
                                    setCaptainInfo(extend)
                                    setIsCaptainPopupShow(false)
                                }
                            }}
                        />
                    ) : <div style={{ color: '#86909c', fontSize: '13px', padding: '10px' }}>暂无符合条件（或已被选为队员）的人员</div>}

                    <span className="create-team-sub-label" style={{ marginTop: '20px' }}>临时队员</span>
                    {filteredMembers
                        .filter(item => [1, 2].includes(item.tempMember))
                        // Exclude players already selected as members
                        .filter(item => !memberList1.includes(item.id) && !memberList2.includes(item.id))
                        .length > 0 ? (
                        <Selector
                            className="premium-selector"
                            columns={3}
                            options={filteredMembers
                                .filter(item => [1, 2].includes(item.tempMember))
                                .filter(item => !memberList1.includes(item.id) && !memberList2.includes(item.id))
                                .map(item => ({ label: item.name, value: item.id }))}
                            onChange={(arr, extend) => {
                                if (extend.items.length > 0) {
                                    setCaptainInfo(extend)
                                    setIsCaptainPopupShow(false)
                                }
                            }}
                        />
                    ) : <div style={{ color: '#86909c', fontSize: '13px', padding: '10px' }}>暂无符合条件（或已被选为队员）的人员</div>}
                </div>
            </Popup>
        </div>
    )
}

